import { render } from "./ProductFeedbackSection.vue?vue&type=template&id=89660e4c&scoped=true&ts=true"
import script from "./ProductFeedbackSection.vue?vue&type=script&lang=ts"
export * from "./ProductFeedbackSection.vue?vue&type=script&lang=ts"

import "./ProductFeedbackSection.vue?vue&type=style&index=0&id=89660e4c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89660e4c"]])

export default __exports__